import queryString from "query-string";
import { apiUrl, client } from "../modules/store";
export function acceptPrivacyPolicy(user) {
  return client.post(`${apiUrl}/account/accept`, {});
}

export function checkPortalStatus(email, url) {
  const object = { email, url };
  const qs = queryString.stringify(object);
  return client.get(`${apiUrl}/auth/portalCheck?${qs}`);
}

export function deactivateUser() {
  return client.get(`${apiUrl}/auth/deactivate`);
}
